const EntitlementIssueSubType = Object.freeze({
  SHARE_PURCHASE_PLAN: "SHARE_PURCHASE_PLAN",
  PRIORITY_ISSUE: "PRIORITY_ISSUE",
  RIGHTS_ISSUE_RENOUNCEABLE: "RIGHTS_ISSUE_RENOUNCEABLE",
  RIGHTS_ISSUE_NON_RENOUNCEABLE: "RIGHTS_ISSUE_NON_RENOUNCEABLE",
  OTHER: "OTHER",
});

export default EntitlementIssueSubType;
